import { FormSchemaMap } from "../index";
import metadataForm from "./metadata-form";

const formSchemaMap: FormSchemaMap = {
  "metadata-form": metadataForm,
};

export default formSchemaMap;
